import React from "react";
import Spinner from "../../../../components/presentationals/Spinner";
import Error from "../../../../components/Error/index";
import ActivationSalesCustomizedTables from "../../../../components/table/activationSalesCustomizedTables";

const Bottom5RetailersView = ({ bottom5RetailersObj }) => {
  let { bottom5RetailersData } = bottom5RetailersObj;

  return (
    <>
      {bottom5RetailersObj.loading ? (
        <Spinner />
      ) : Object.keys(bottom5RetailersData).length ? (
        <ActivationSalesCustomizedTables data={bottom5RetailersData} />
      ) : (
        <Error error={bottom5RetailersObj.error} />
      )}
    </>
  );
};

export default Bottom5RetailersView;
